"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureUnitTextMap = void 0;
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
/** 计量单位中文翻译 */
exports.MeasureUnitTextMap = {
    [spu_1.MeasureUnitEnum.Day]: '天',
    [spu_1.MeasureUnitEnum.Hour]: '小时',
    [spu_1.MeasureUnitEnum.Minute]: '分钟',
    [spu_1.MeasureUnitEnum.Second]: '秒',
    [spu_1.MeasureUnitEnum.Month]: '月',
    [spu_1.MeasureUnitEnum.Year]: '年',
    [spu_1.MeasureUnitEnum.Times]: '次',
    [spu_1.MeasureUnitEnum.TimesPerSecond]: '次/秒',
    [spu_1.MeasureUnitEnum.Pcs]: '个',
    [spu_1.MeasureUnitEnum.PcsPerSecond]: '个/秒',
    [spu_1.MeasureUnitEnum.Byte]: 'Byte',
    [spu_1.MeasureUnitEnum.KB]: 'KB',
    [spu_1.MeasureUnitEnum.MB]: 'MB',
    [spu_1.MeasureUnitEnum.GB]: 'GB',
    [spu_1.MeasureUnitEnum.TB]: 'TB',
    [spu_1.MeasureUnitEnum.PB]: 'PB',
    [spu_1.MeasureUnitEnum.KiB]: 'KiB',
    [spu_1.MeasureUnitEnum.MiB]: 'MiB',
    [spu_1.MeasureUnitEnum.GiB]: 'GiB',
    [spu_1.MeasureUnitEnum.TiB]: 'TiB',
    [spu_1.MeasureUnitEnum.PiB]: 'PiB',
    [spu_1.MeasureUnitEnum.BytePerSecond]: 'Byte/秒',
    [spu_1.MeasureUnitEnum.KiBPerSecond]: 'KiB/秒',
    [spu_1.MeasureUnitEnum.MiBPerSecond]: 'MiB/秒',
    [spu_1.MeasureUnitEnum.GiBPerSecond]: 'GiB/秒',
    [spu_1.MeasureUnitEnum.None]: '',
};
